import React, {useEffect, useState} from 'react';
import {useAuth} from "../../AuthContext";
import "./Peak.css";
import { Table } from "../../lv1ui";

    const PAGE_SIZE_OPTIONS = [50, 100, 500];
    const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0]; // 👈 всегда берём первый
    const CAMPAIGNER_DEFAULT_DAYS = 5;
    const CAMPAIGNER_EXTENDED_DAYS = 29;
export function Peak() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [campaignerId, setCampaignerId] = useState('');
    const [price, setPrice] = useState('0.00');
    const [campaignerWAButton, setCampaignerWAButton] = useState('');
    const [priceWAButton, setPriceWAButton] = useState('0.00');
    const [campaignerImo, setCampaignerImo] = useState('');
    const [priceImo, setPriceImo] = useState('0.00');
    const [campaignerViber, setCampaignerViber] = useState('');
    const [priceViber, setPriceViber] = useState('0.00');
    const [campaignerKakaoTalk, setCampaignerKakaoTalk] = useState('');
    const [priceKakaoTalk, setPriceKakaoTalk] = useState('0.00');
    const [campaignerTg, setCampaignerTg] = useState('');
    const [priceTg, setPriceTg] = useState('0.00');
    const [deliveryMode, setDeliveryMode] = useState('default'); // 'default' | 'file_save' | 'split' | 'alternative' | 'belwa'
    const [webhookUrl, setWebhookUrl] = useState('');
    const [webhookUrlTelegram, setWebhookUrlTelegram] = useState('');
    const [startBalance, setStartBalance] = useState('0.00');

    const [message, setMessage] = useState(null);

    const [users, setUsers] = useState([]);
    const [editingUserId, setEditingUserId] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [userCampaigns, setUserCampaigns] = useState([]);
    const [selectedCampaignId, setSelectedCampaignId] = useState(null);
    const [campaignMessages, setCampaignMessages] = useState([]);

    const [sendCronValue, setSendCronValue] = useState('');
    const [nextKeyValue, setNextKeyValue] = useState('');
    const [checkwaLoadLimitValue, setCheckwaLoadLimitValue] = useState('');
    const [settingsMessage, setSettingsMessage] = useState('');

    const [manualKeyIndex, setManualKeyIndex] = useState('0');
    const [manualLimit, setManualLimit] = useState('1000');
    const [manualSendMessage, setManualSendMessage] = useState('');
    const [customBucketLimit, setCustomBucketLimit] = useState('1000');
    const [customBucketUserScope, setCustomBucketUserScope] = useState('all');
    const [customBucketUserId, setCustomBucketUserId] = useState('');
    const [customBucketChannel, setCustomBucketChannel] = useState('all');
    const [customBucketSaving, setCustomBucketSaving] = useState(false);
    const [customBucketMessage, setCustomBucketMessage] = useState('');

    const [manualPaymentUserId, setManualPaymentUserId] = useState('');
    const [manualPaymentAmount, setManualPaymentAmount] = useState('');
    const [manualPaymentWithDebt, setManualPaymentWithDebt] = useState(false);
    const [manualPaymentComment, setManualPaymentComment] = useState('');
    const [manualPaymentMessage, setManualPaymentMessage] = useState('');

    const [manualWithdrawUserId, setManualWithdrawUserId] = useState('');
    const [manualWithdrawAmount, setManualWithdrawAmount] = useState('');
    const [manualWithdrawFromDebt, setManualWithdrawFromDebt] = useState(false);
    const [manualWithdrawComment, setManualWithdrawComment] = useState('');
    const [manualWithdrawMessage, setManualWithdrawMessage] = useState('');

    const CHANNELS = ['whatsapp','wabutton','telegram','viber','imo','kakaotalk'];
    const [campaignerIdsByChannel, setCampaignerIdsByChannel] = useState({
        whatsapp: [], wabutton: [], telegram: [], viber: [], imo: [], kakaotalk: []
    });
    const [daysByChannel, setDaysByChannel] = useState({
        whatsapp: [], wabutton: [], telegram: [], viber: [], imo: [], kakaotalk: []
    });
    const [campaignerStatsDays, setCampaignerStatsDays] = useState(CAMPAIGNER_DEFAULT_DAYS);
    const [campaignerStatsLoading, setCampaignerStatsLoading] = useState(false);
    const [campaignerStatsMessage, setCampaignerStatsMessage] = useState('');

    const [balanceMap, setBalanceMap] = useState({});

    const [showCreate, setShowCreate] = useState(false);

    const [fileDates, setFileDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedType, setSelectedType] = useState('filesave');
const [selectedChannel, setSelectedChannel] = useState('whatsapp');
    const [fileList, setFileList] = useState([]);

const [showAllMsgs, setShowAllMsgs] = useState(false);
const [allMessages, setAllMessages] = useState([]);
const [allPagination, setAllPagination] = useState({
  page: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0, totalPages: 0,
});

const [cmFilters, setCmFilters] = useState({
  type: '', status: '', source: '', method: '',
  date_from: '', date_to: '', phone: ''
});

// для таблички All user messages
const [allFilters, setAllFilters] = useState({
  type: '', status: '', source: '', method: '',
  date_from: '', date_to: '', phone: ''
});

    // Глобальные "все сообщения"
    const [showGlobalMsgs, setShowGlobalMsgs] = useState(false);
    const [globalMessages, setGlobalMessages] = useState([]);
    const [gmPagination, setGmPagination] = useState({
        page: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0, totalPages: 0,
    });

    const [gmFilters, setGmFilters] = useState({
        type:'', status:'', source:'', method:'', date_from:'', date_to:'', phone:''
    });

const BUCKET_CONFIG = [
    { key: '03', label: '00:00-02:59' },
    { key: '06', label: '03:00-05:59' },
    { key: '09', label: '06:00-08:59' },
    { key: '12', label: '09:00-11:59' },
    { key: '15', label: '12:00-14:59' },
    { key: '18', label: '15:00-17:59' },
    { key: '21', label: '18:00-20:59' },
    { key: '24', label: '21:00-23:59' },
];
const BUCKET_LABELS = Object.fromEntries(BUCKET_CONFIG.map(bucket => [bucket.key, bucket.label]));

function getBucketFromFilename(name) {
    const m = name.match(/-(03|06|09|12|15|18|21|24)\.jsonl$/);
    return m ? m[1] : 'other';
}

function getCustomBucketFromFilename(name) {
    const m = name.match(/-(1\d{2})\.jsonl$/);
    return m ? m[1] : null;
}

function bucketLabel(bucket) {
    if (BUCKET_LABELS[bucket]) return BUCKET_LABELS[bucket];
    switch (bucket) {
        case '06': return '00:00–05:59';
        case '12': return '06:00–11:59';
        case '18': return '12:00–17:59';
        case '24': return '18:00–23:59';
        default: return 'Other';
    }
}

function groupFilesByBucket(files) {
    const groups = Object.fromEntries(BUCKET_CONFIG.map(bucket => [bucket.key, []]));
    groups.other = [];

    for (const f of files) {
        const bucket = getBucketFromFilename(f.name);
        groups[bucket].push(f);
    }

    return groups;
}

function groupFilesByCustomBucket(files) {
    return files.reduce((acc, f) => {
        const bucket = getCustomBucketFromFilename(f.name);

        if (!bucket) {
            return acc;
        }

        (acc[bucket] ||= []).push(f);
        return acc;
    }, {});
}

function zipDownloadName(name) {
    return name.replace(/\.[^.]+$/, '') + '.zip';
}

async function downloadMergedBucket(bucket) {
    const url = `/api/admin/files/download-merged?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&channel=${encodeURIComponent(selectedChannel)}&bucket=${encodeURIComponent(bucket)}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) {
        alert('Merged download error');
        return;
    }
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${selectedChannel}-${selectedType}-${selectedDate}-${bucket}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
}

    const createManualPayment = async () => {
        setManualPaymentMessage('');

        const userId = Number(manualPaymentUserId);
        const amount = Number(manualPaymentAmount);

        if (!Number.isInteger(userId) || userId <= 0) {
            setManualPaymentMessage('❌ Select user');
            return;
        }

        if (!Number.isFinite(amount) || amount <= 0) {
            setManualPaymentMessage('❌ Enter valid amount');
            return;
        }

        const selectedUser = users.find(u => Number(u.id) === userId);
        const confirmText = manualPaymentWithDebt
            ? `Начислить $${amount} пользователю ${selectedUser?.username || `#${userId}`} и добавить эту сумму в долг?`
            : `Начислить $${amount} пользователю ${selectedUser?.username || `#${userId}`} без долга?`;

        if (!window.confirm(confirmText)) {
            return;
        }

        try {
            const res = await fetchWithAuth('/api/admin/manual-payment', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userId,
                    amount,
                    withDebt: manualPaymentWithDebt,
                    comment: manualPaymentComment || null
                })
            });

            const data = await res.json();

            if (!res.ok) {
                setManualPaymentMessage(`❌ ${data.error || 'Manual payment failed'}`);
                return;
            }

            setManualPaymentMessage(
                `✅ Added $${data.amount} to user #${data.userId}. Debt added: $${data.debtAdded}`
            );

            setManualPaymentAmount('');
            setManualPaymentWithDebt(false);
            setManualPaymentComment('');

            await fetchUsers();
        } catch (err) {
            setManualPaymentMessage('❌ Network error');
        }
    };

    const createManualWithdraw = async () => {
        setManualWithdrawMessage('');

        const userId = Number(manualWithdrawUserId || selectedUserId);
        const amount = Number(manualWithdrawAmount);

        if (!Number.isInteger(userId) || userId <= 0) {
            setManualWithdrawMessage('❌ Select user');
            return;
        }

        if (!Number.isFinite(amount) || amount <= 0) {
            setManualWithdrawMessage('❌ Enter valid amount');
            return;
        }

        const selectedUser = users.find(u => Number(u.id) === userId);
        const confirmText = manualWithdrawFromDebt
            ? `Списать $${amount} у ${selectedUser?.username || `#${userId}`} и уменьшить долг на эту же сумму?`
            : `Списать $${amount} у ${selectedUser?.username || `#${userId}`} без изменения долга?`;

        if (!window.confirm(confirmText)) {
            return;
        }

        try {
            const res = await fetchWithAuth('/api/admin/manual-withdraw', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userId,
                    amount,
                    fromDebt: manualWithdrawFromDebt,
                    comment: manualWithdrawComment || null
                })
            });

            const data = await res.json();

            if (!res.ok) {
                setManualWithdrawMessage(`❌ ${data.error || 'Manual withdraw failed'}`);
                return;
            }

            setManualWithdrawMessage(
                `✅ Withdrawn $${data.amount} from user #${data.userId}. Debt reduced: $${data.debtReduced}`
            );

            setManualWithdrawAmount('');
            setManualWithdrawFromDebt(false);
            setManualWithdrawComment('');

            await fetchUsers();
        } catch (err) {
            setManualWithdrawMessage('❌ Network error');
        }
    };

    const runManualCheckwaSend = async () => {
        setManualSendMessage('');

        if (manualKeyIndex === '' || manualLimit === '') {
            setManualSendMessage('❌ keyIndex and limit are required');
            return;
        }

        try {
            const res = await fetchWithAuth('/api/admin/checkwa/send-now', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    keyIndex: Number(manualKeyIndex),
                    limit: Number(manualLimit)
                })
            });

            const data = await res.json();

            if (!res.ok) {
                setManualSendMessage(`❌ ${data.error}`);
                return;
            }

            setManualSendMessage(
                `✅ Manual send done. Key: ${data.used_key_label}, limit: ${data.limit}`
            );

            fetchSettings();
        } catch (err) {
            setManualSendMessage('❌ Manual send failed');
        }
    };

    const runCustomBucketSave = async () => {
        setCustomBucketMessage('');

        const limit = Number(customBucketLimit);

        if (!Number.isInteger(limit) || limit <= 0 || limit > 50000) {
            setCustomBucketMessage('Limit must be an integer from 1 to 50000');
            return;
        }

        const payload = {
            limit,
            userScope: customBucketUserScope,
            userId: null,
            channel: customBucketChannel
        };

        if (customBucketUserScope === 'single') {
            const userId = Number(customBucketUserId);

            if (!Number.isInteger(userId) || userId <= 1) {
                setCustomBucketMessage('Enter userId greater than 1');
                return;
            }

            payload.userId = userId;
        }

        setCustomBucketSaving(true);

        try {
            const res = await fetchWithAuth('/api/admin/checkwa/save-custom-bucket', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const data = await res.json().catch(() => ({}));

            if (!res.ok) {
                setCustomBucketMessage(data.error || 'Custom bucket save failed');
                return;
            }

            if (!data.bucket) {
                setCustomBucketMessage('No pending messages matched the custom bucket filters');
                return;
            }

            const nextSelectedChannel = customBucketChannel === 'all' ? selectedChannel : customBucketChannel;

            setSelectedDate(data.date);
            setSelectedType('filesave');
            setSelectedChannel(nextSelectedChannel);
            const filesByType = (data.filesWritten || []).reduce((acc, file) => {
                acc[file.type] = (acc[file.type] || 0) + 1;
                return acc;
            }, {});
            setCustomBucketMessage(
                `Saved custom bucket ${data.bucket} for ${data.date}. Messages: ${data.messages}, filesave files: ${filesByType.filesave || 0}, split files: ${filesByType.split || 0}`
            );

            await loadDates();
            await loadFiles(data.date, 'filesave', nextSelectedChannel);
        } catch (err) {
            setCustomBucketMessage('Custom bucket save failed');
        } finally {
            setCustomBucketSaving(false);
        }
    };

async function downloadMergedStatuses(bucket) {
    const url = `/api/admin/files/statuses-merged?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&channel=${encodeURIComponent(selectedChannel)}&bucket=${encodeURIComponent(bucket)}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) {
        alert('Merged statuses export error');
        return;
    }
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `stat-${selectedChannel}-${selectedType}-${selectedDate}-${bucket}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
}

async function downloadMergedXlsx(bucket, withHeader = false) {
    const url = `/api/admin/files/xlsx-merged?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&channel=${encodeURIComponent(selectedChannel)}&bucket=${encodeURIComponent(bucket)}&withHeader=${withHeader ? '1' : '0'}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) {
        alert('Merged XLSX download error');
        return;
    }
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `xlsx-${selectedChannel}-${selectedType}-${selectedDate}-${bucket}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
}

    const fetchSettings = async () => {
        const res = await fetchWithAuth('/api/admin/settings/runtime');
        const data = await res.json();

        if (data.success) {
            setNextKeyValue(String(data.settings.checkwa_next_key_index ?? ''));
            setCheckwaLoadLimitValue(String(data.settings.checkwa_load_limit ?? ''));
            setSendCronValue(String(data.settings.send_cron_template ?? ''));
        }
    };

function buildQuery(params) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k,v]) => {
    if (v !== undefined && v !== null && String(v).trim() !== '') usp.append(k, v);
  });
  return usp.toString();
}

    const fetchGlobalMessages = async (page = 1, limit = DEFAULT_PAGE_SIZE) => {
        const qs = buildQuery({ page, limit, ...gmFilters });
        const res = await fetchWithAuth(`/api/admin/all/messages?${qs}`);
        const data = await res.json();
        if (data.success) {
            setGlobalMessages(data.data);
            setGmPagination({
                page: data.page, pageSize: data.pageSize, total: data.total, totalPages: data.totalPages
            });
        }
    };

const fetchAllMessages = async (page=1, limit=DEFAULT_PAGE_SIZE) => {
  if (!selectedUserId) return;
  const qs = buildQuery({ page, limit, ...allFilters });
  const res = await fetchWithAuth(`/api/admin/users/${selectedUserId}/messages?${qs}`);
  const data = await res.json();
  if (data.success) {
    setAllMessages(data.data);
    setAllPagination({ page:data.page, pageSize:data.pageSize, total:data.total, totalPages:data.totalPages });
  }
};
    async function loadDates() {
        const res = await fetchWithAuth('/api/admin/files/dates');
        const data = await res.json();
        if (data.success) {
            setFileDates(data.dates);
            if (!selectedDate && data.dates.length) {
                setSelectedDate(data.dates[0]);
            }
        }
    }

async function loadFiles(date = selectedDate, type = selectedType, channel = selectedChannel) {
    if (!date) return;
    const res = await fetchWithAuth(
        `/api/admin/files/list?date=${encodeURIComponent(date)}&type=${encodeURIComponent(type)}&channel=${encodeURIComponent(channel)}`
    );
    const data = await res.json();
    if (data.success) setFileList(data.files);
}

    useEffect(() => {
        loadDates();
    }, []);

useEffect(() => {
    if (selectedDate) loadFiles(selectedDate, selectedType, selectedChannel);
}, [selectedDate, selectedType, selectedChannel]);

    async function downloadFile(name) {
        const url = `/api/admin/files/download?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&name=${encodeURIComponent(name)}`;
        const res = await fetchWithAuth(url);
        if (!res.ok) {
            alert('Download error');
            return;
        }
        const blob = await res.blob();
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = zipDownloadName(name); // подсказка имени файла
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(a.href);
    }
async function downloadStatuses(name) {
  const url = `/api/admin/files/statuses?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&name=${encodeURIComponent(name)}`;
  const res = await fetchWithAuth(url);
  if (!res.ok) {
    alert('Statuses export error');
    return;
  }
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  // имя будет выставлено Content-Disposition, но продублируем для совместимости
  const base = name.replace(/\.[^.]+$/, '');
  a.download = `stat-${base}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}

async function downloadXlsx(name, withHeader = true) {
  const url = `/api/admin/files/xlsx?date=${encodeURIComponent(selectedDate)}&type=${encodeURIComponent(selectedType)}&name=${encodeURIComponent(name)}&withHeader=${withHeader ? '1' : '0'}`;
  const res = await fetchWithAuth(url);
  if (!res.ok) {
    alert('XLSX download error');
    return;
  }
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `xlsx-${name.replace(/\.[^.]+$/,'')}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}


    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        total: 0,
        totalPages: 0,
    });

    const { fetchWithAuth } = useAuth();

    const resetUserForm = () => {
        setEditingUserId(null);
        setUsername('');
        setPassword('');
        setCampaignerId('');
        setCampaignerWAButton('');
        setCampaignerImo('');
        setCampaignerViber('');
        setCampaignerKakaoTalk('');
        setCampaignerTg('');
        setPrice('0.00');
        setPriceWAButton('0.00');
        setPriceImo('0.00');
        setPriceViber('0.00');
        setPriceKakaoTalk('0.00');
        setPriceTg('0.00');
        setDeliveryMode('default');
        setWebhookUrl('');
        setWebhookUrlTelegram('');
        setStartBalance('0.00');
    };

    const numberOrZero = (value) => (isNaN(parseFloat(value)) ? 0.00 : parseFloat(value));
    const intOrNull = (value) => (value === '' || value === null || value === undefined ? null : parseInt(value, 10));
    const getUserBalanceAlert = (user) => {
        const balance = numberOrZero(user.balance);
        const debt = numberOrZero(user.debt);
        const available = balance - debt;

        if (available < 0) return { level: 'debt', available };
        if (available < 500) return { level: 'low', available };
        return { level: null, available };
    };

    const renderUserMoney = (value, alert, badge) => (
        <span
            className={`userBalanceValue${alert.level ? ` userBalanceValue--${alert.level}` : ''}`}
            title={`Balance - debt = $${alert.available.toFixed(2)}`}
        >
            <span>${value ?? 0}</span>
            {badge && alert.level && (
                <span className={`userBalanceBadge userBalanceBadge--${alert.level}`}>
                    {alert.level === 'debt' ? 'DEBT' : 'LOW'}
                </span>
            )}
        </span>
    );

    const buildUserPayload = () => ({
        username,
        ...(password ? { password } : {}),
        price_wa: numberOrZero(price),
        price_wabutton: numberOrZero(priceWAButton),
        price_imo: numberOrZero(priceImo),
        price_viber: numberOrZero(priceViber),
        price_kakaotalk: numberOrZero(priceKakaoTalk),
        price_telegram: numberOrZero(priceTg),
        campaigner_id: intOrNull(campaignerId),
        campaigner_wabutton: intOrNull(campaignerWAButton),
        campaigner_imo: intOrNull(campaignerImo),
        campaigner_viber: intOrNull(campaignerViber),
        campaigner_kakaotalk: intOrNull(campaignerKakaoTalk),
        campaigner_telegram: intOrNull(campaignerTg),
        delivery_mode: deliveryMode,
        webhook_url: webhookUrl || null,
        webhook_url_telegram: webhookUrlTelegram || null,
        balance: numberOrZero(startBalance)
    });

    const fillUserForm = (user) => {
        setEditingUserId(user.id);
        setUsername(user.username || '');
        setPassword('');
        setCampaignerId(user.campaigner_id ?? '');
        setCampaignerWAButton(user.campaigner_wabutton ?? '');
        setCampaignerImo(user.campaigner_imo ?? '');
        setCampaignerViber(user.campaigner_viber ?? '');
        setCampaignerKakaoTalk(user.campaigner_kakaotalk ?? '');
        setCampaignerTg(user.campaigner_telegram ?? '');
        setPrice(user.price_wa ?? '0.00');
        setPriceWAButton(user.price_wabutton ?? '0.00');
        setPriceImo(user.price_imo ?? '0.00');
        setPriceViber(user.price_viber ?? '0.00');
        setPriceKakaoTalk(user.price_kakaotalk ?? '0.00');
        setPriceTg(user.price_telegram ?? '0.00');
        setDeliveryMode(user.delivery_mode || 'default');
        setWebhookUrl(user.webhook_url || '');
        setWebhookUrlTelegram(user.webhook_url_telegram || '');
        setStartBalance(user.balance ?? '0.00');
        setMessage(null);
        setShowCreate(true);
    };

    const handleRegister = async () => {
        setMessage(null);
        if (!username || (!editingUserId && !password)) {
            setMessage('Please fill in all fields');
            return;
        }

        const waOK = campaignerId && !isNaN(parseFloat(price));
        const waButtonOK = campaignerWAButton && !isNaN(parseFloat(priceWAButton));
        const imoOK = campaignerImo && !isNaN(parseFloat(priceImo));
        const viberOK = campaignerViber && !isNaN(parseFloat(priceViber));
        const kakaoOK = campaignerKakaoTalk && !isNaN(parseFloat(priceKakaoTalk));
        const tgOK = campaignerTg && !isNaN(parseFloat(priceTg));

        if (!waOK && !waButtonOK && !imoOK && !viberOK && !kakaoOK && !tgOK) {
            setMessage('Specify price and campaigner ID for at least one channel');
            return;
        }

        try {
            const res = await fetchWithAuth(editingUserId ? `/api/admin/users/${editingUserId}` : '/api/admin/register', {
                method: editingUserId ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(buildUserPayload())
            });
            const data = await res.json();
            if (res.ok) {
                setMessage(editingUserId ? 'User successfully updated' : 'User successfully created');
                resetUserForm();
                await fetchUsers();
            } else {
                setMessage(`❌ Error: ${data.error}`);
            }
        } catch (err) {
            setMessage('❌ Network error');
        }
    };

    const fetchBalanceSnapshots = async () => {
        const res = await fetchWithAuth('/api/admin/balance-snapshots');
        const data = await res.json();
        if (data.success) {
            const map = {};
            data.data.forEach(r => {
                map[`${r.user_id}_${r.snapshot_date}`] = parseFloat(r.balance);
            });
            setBalanceMap(map);
        }
    };

    const fetchUsers = async () => {
        const res = await fetchWithAuth('/api/admin/users');
        const data = await res.json();
        if (data.success) setUsers(data.users);
    };

    const fetchUserCampaigns = async (userId) => {
        setSelectedUserId(userId);
        const res = await fetchWithAuth(`/api/admin/campaigns/${userId}`);
        const data = await res.json();
        if (data.success) setUserCampaigns(data.campaigns);
    };

const fetchCampaignMessages = async (campaignId, page=1, limit=DEFAULT_PAGE_SIZE) => {
  setSelectedCampaignId(campaignId);
  const qs = buildQuery({ page, limit, ...cmFilters });
  const res = await fetchWithAuth(`/api/admin/campaign/${campaignId}?${qs}`);
  const data = await res.json();
  if (data.success) {
    setCampaignMessages(data.data);
    setPagination({ page: data.page, pageSize: data.pageSize, total: data.total, totalPages: data.totalPages });
  }
};
    const fetchCampaignerIds = async (channel, days = CAMPAIGNER_DEFAULT_DAYS) => {
        const res = await fetchWithAuth(`/api/admin/campaignerIds?channel=${encodeURIComponent(channel)}&days=${encodeURIComponent(days)}`);
        const data = await res.json();

        if (data.success) {
            setCampaignerIdsByChannel(prev => ({ ...prev, [channel]: data.data }));
            const uniqDays = [...new Set(data.data.map(r => r.day))]
                .sort((a,b) => new Date(b) - new Date(a));
            setDaysByChannel(prev => ({ ...prev, [channel]: uniqDays }));
        }

    };

    const loadCampaignerStats = async (days = CAMPAIGNER_DEFAULT_DAYS) => {
        setCampaignerStatsLoading(true);
        setCampaignerStatsMessage('');

        try {
            await Promise.all(CHANNELS.map(ch => fetchCampaignerIds(ch, days)));
            setCampaignerStatsDays(days);
        } catch (err) {
            setCampaignerStatsMessage('Campaigner stats loading failed');
        } finally {
            setCampaignerStatsLoading(false);
        }
    };

    const saveSendCron = async () => {
        const res = await fetchWithAuth('/api/admin/settings/send-cron', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ value: sendCronValue })
        });

        const data = await res.json();
        setSettingsMessage(data.success ? '✅ Cron saved' : `❌ ${data.error}`);
        if (data.success) fetchSettings();
    };

    const saveNextKey = async () => {
        if (nextKeyValue === '') {
            setSettingsMessage('❌ key index is required');
            return;
        }

        const res = await fetchWithAuth('/api/admin/settings/checkwa-next-key', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ keyNumber: Number(nextKeyValue) })
        });

        const data = await res.json();
        setSettingsMessage(data.success ? '✅ Key saved' : `❌ ${data.error}`);
        if (data.success) fetchSettings();
    };

    const saveCheckwaLoadLimit = async () => {
        if (checkwaLoadLimitValue === '') {
            setSettingsMessage('❌ limit is required');
            return;
        }

        const res = await fetchWithAuth('/api/admin/settings/checkwa-load-limit', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ value: Number(checkwaLoadLimitValue) })
        });

        const data = await res.json();
        setSettingsMessage(data.success ? '✅ Limit saved' : `❌ ${data.error}`);
        if (data.success) fetchSettings();
    };


    useEffect(() => {
        fetchUsers();
        loadCampaignerStats(CAMPAIGNER_DEFAULT_DAYS);
        fetchBalanceSnapshots();   // 👈 вот это
        fetchSettings();
    }, []);

useEffect(() => {
  // при выборе нового пользователя скрываем таблицу "все сообщения" и сбрасываем данные
  setShowAllMsgs(false);
  setAllMessages([]);
  setAllPagination({ page: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0, totalPages: 0 });
}, [selectedUserId]);

    // ==== таблица Users ====
    const userColumns = [
        { key: "id", label: "#" },
        { key: "username", label: "Username" },
        { key: "created_at", label: "Registration Date" },
        { key: "balance", label: "Balance" },
        { key: "debt", label: "Debt" },
        { key: "campaigner_id", label: "CampaignerWA" },
        { key: "price_wa", label: "PriceWA" },
        { key: "campaigner_wabutton", label: "CampaignerWAButton" },
        { key: "price_wabutton", label: "PriceWAButton" },
        { key: "campaigner_imo", label: "CampaignerImo" },
        { key: "price_imo", label: "PriceImo" },
        { key: "campaigner_viber", label: "CampaignerV" },
        { key: "price_viber", label: "PriceV" },
        { key: "campaigner_kakaotalk", label: "CampaignerKakao" },
        { key: "price_kakaotalk", label: "PriceKakao" },
        { key: "campaigner_telegram", label: "CampaignerTG" },
        { key: "price_telegram", label: "PriceTG" },
        { key: "campaign_count", label: "Campaigns Amount" },
        { key: "last_campaign_date", label: "Last Campaign" },

        { key: "delivery_mode", label: "Mode" },
        { key: "webhook_url", label: "Webhook" },
        { key: "webhook_url_telegram", label: "Webhook TG" },
        { key: "actions", label: "Actions" },
    ];
    const userRows = users.map((s) => {
        const balanceAlert = getUserBalanceAlert(s);

        return {
        ...s,
        created_at: new Date(s.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
        balance: renderUserMoney(s.balance, balanceAlert, true),
        debt: renderUserMoney(s.debt ?? 0, balanceAlert, false),
        webhook_url: s.webhook_url
            ? <span title={s.webhook_url}>
        {s.webhook_url.length > 30 ? s.webhook_url.slice(0, 30) + '…' : s.webhook_url}
      </span>
            : "",
        webhook_url_telegram: s.webhook_url_telegram
            ? <span title={s.webhook_url_telegram}>
      {s.webhook_url_telegram.length > 30 ? s.webhook_url_telegram.slice(0,30)+'…' : s.webhook_url_telegram}
    </span> : "",
        last_campaign_date: s.last_campaign_date
            ? new Date(s.last_campaign_date).toLocaleString('en-GB', { timeZone: 'UTC' })
            : "-",
        actions: (
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    fillUserForm(s);
                }}
            >
                Edit
            </button>
        ),
        onClick: () => fetchUserCampaigns(s.id),
        };
    });

    // ==== таблица Campaigns ====
    const campaignColumns = [
        { key: "id", label: "ID" },
        { key: "name", label: "Name" },
        { key: "message", label: "Message" },
        { key: "created_at", label: "Created At" },
        { key: "channel", label: "Type" },
        { key: "total", label: "Total" },
        { key: "pending", label: "Pending" },
        { key: "sent", label: "Sent" },
        { key: "noaccount", label: "No Account" },
        { key: "delivered", label: "Delivered" },
        { key: "failed", label: "Failed" },
        { key: "undelivered", label: "Undelivered" },
    ];
    const campaignRows = userCampaigns.map((m) => ({
        ...m,
        message: m.message?.slice(0, 30) + "...",
        created_at: new Date(m.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
        onClick: () => fetchCampaignMessages(m.id),
    }));

    // ==== таблица Messages ====
    const msgColumns = [
        { key: "id", label: "ID" },
        { key: "dst_addr", label: "Phone Number" },
        { key: "field_1", label: "Field 1" },
        { key: "status", label: "Status" },
        { key: "price", label: "Price" },
        { key: "text", label: "Text" },
{ key: "source", label: "Source" },               // <—
        { key: "dispatch_method", label: "Delivery method" },
        { key: "created_at", label: "Created At" },
        { key: "status_updated_at", label: "Updated At" },
    ];
    const msgRows = campaignMessages.map((m) => ({
        ...m,
                dst_addr: m.dst_addr
            ? <span title={m.dst_addr}>{m.dst_addr}</span>
            : "",
        text: m.text
            ? <span title={m.text}>{`${m.text.slice(0, 30)}...`}</span>
            : "",
        created_at: new Date(m.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
        status_updated_at: new Date(m.status_updated_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
source: m.source || "",                           // <—
        dispatch_method: m.dispatch_method
    }));

const allMsgColumns = [
  { key: "id", label: "ID" },
  { key: "campaign_id", label: "Campaign" },
  { key: "channel", label: "Type" },
  { key: "dst_addr", label: "Phone" },
  { key: "status", label: "Status" },
  { key: "price", label: "Price" },
  { key: "text", label: "Text" },
  { key: "source", label: "Source" },
  { key: "dispatch_method", label: "Delivery method" },
  { key: "created_at", label: "Created" },
  { key: "status_updated_at", label: "Updated" },
];


const allMsgRows = allMessages.map(m => ({
  ...m,
  channel: (m.channel || '').toUpperCase(),
  dst_addr: m.dst_addr ? <span title={m.dst_addr}>{m.dst_addr}</span> : "",
  text: m.text ? <span title={m.text}>{`${m.text.slice(0,30)}...`}</span> : "",
  source: m.source || "",
  dispatch_method: m.dispatch_method,
  created_at: new Date(m.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
  status_updated_at: new Date(m.status_updated_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
}));

const globalMsgColumns = [
        { key: "id", label: "ID" },
        { key: "campaign_id", label: "Campaign" },
        { key: "channel", label: "Type" },
        { key: "dst_addr", label: "Phone" },
        { key: "status", label: "Status" },
        { key: "price", label: "Price" },
        { key: "text", label: "Text" },
        { key: "source", label: "Source" },
        { key: "dispatch_method", label: "Delivery method" },
        { key: "created_at", label: "Created" },
        { key: "status_updated_at", label: "Updated" },
    ];

    const globalMsgRows = globalMessages.map(m => ({
        ...m,
        channel: (m.channel || '').toUpperCase(),
        dst_addr: m.dst_addr ? <span title={m.dst_addr}>{m.dst_addr}</span> : "",
        text: m.text ? <span title={m.text}>{`${m.text.slice(0,30)}...`}</span> : "",
        source: m.source || "",
        dispatch_method: m.dispatch_method,
        created_at: new Date(m.created_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
        status_updated_at: new Date(m.status_updated_at).toLocaleString('en-GB', { timeZone: 'UTC' }),
    }));


    function buildGrid(data) {
        // сгруппировать как прежде: campaigner_id -> {__users, day -> rec}
        return data.reduce((acc, r) => {
            const cid = r.campaigner_id;
            if (!acc[cid]) acc[cid] = { __users: [] };
            r.user_ids.forEach((uid, i) => {
                const uname = r.usernames[i];
                if (!acc[cid].__users.find(u => u.id === uid)) {
                    acc[cid].__users.push({ id: uid, username: uname });
                }
            });
            acc[cid][r.day] = r;
            return acc;
        }, {});
    }

    function makeGridColumns(days, title) {
        return [
            { key: "cid", label: `${title} — Campaigner / Users` },
            ...days.map(d => ({ key: d, label: new Date(d).toLocaleDateString() })),
        ];
    }

    const GRID_STAT_KEYS = [
        'total',
        'sent_cnt',
        'sent_custom_cnt',
        'noaccount_cnt',
        'delivered_cnt',
        'failed_cnt',
        'undelivered_cnt',
        'checking_cnt',
        'expired_cnt',
    ];

    function makeEmptyGridStats() {
        return GRID_STAT_KEYS.reduce((acc, key) => {
            acc[key] = 0;
            return acc;
        }, {});
    }

    function addGridStats(target, source) {
        GRID_STAT_KEYS.forEach(key => {
            const value = Number(source?.[key]);
            target[key] += Number.isFinite(value) ? value : 0;
        });
    }

    function renderGridStats(rec, users = [], day = null) {
        return (
            <>
                T:{rec.total}<br/>
                s:{rec.sent_cnt}<br/>
                s*:{rec.sent_custom_cnt}<br/>
                n:{rec.noaccount_cnt}<br/>
                d:{rec.delivered_cnt}<br/>
                f:{rec.failed_cnt}<br/>
                u:{rec.undelivered_cnt}<br/>
                cwa:{rec.checking_cnt}<br/>
                exp:{rec.expired_cnt}<br/>
                {day && users.map(u => {
                    const bal = balanceMap[`${u.id}_${day}`];
                    return <div key={u.id}>{u.username}: {bal !== undefined ? bal : "n/a"}</div>;
                })}
            </>
        );
    }

    function makeGridRows(gridObj, days, balanceMap) {
        const entries = Object.entries(gridObj);
        if (!entries.length) return [];

        const totalByDay = days.reduce((acc, day) => {
            acc[day] = makeEmptyGridStats();
            return acc;
        }, {});

        entries.forEach(([, dayMap]) => {
            days.forEach(day => {
                if (dayMap[day]) addGridStats(totalByDay[day], dayMap[day]);
            });
        });

        const totalRow = {
            cid: (
                <>
                    <strong>Total</strong><br/>
                    All clients
                </>
            )
        };

        days.forEach(day => {
            totalRow[day] = renderGridStats(totalByDay[day]);
        });

        const campaignerRows = entries.map(([cid, dayMap]) => {
            const row = {
                cid: (
                    <>
                        <strong>{cid}</strong><br/>
                        {dayMap.__users.map(u => u.username).join(", ")}
                    </>
                )
            };
            days.forEach(d => {
                const rec = dayMap[d] || {
                    total:0, sent_cnt:0, sent_custom_cnt:0, noaccount_cnt:0,
                    delivered_cnt:0, failed_cnt:0, undelivered_cnt:0,
                    checking_cnt:0, expired_cnt:0
                };
                row[d] = renderGridStats(rec, dayMap.__users, d);
            });
            return row;
        });

        return [totalRow, ...campaignerRows];
    }
    return (
        <div className='peakPage'>
            <div className='peakContainer'>
                <div className="labelP peakCreateHeader">
                    <button
                        onClick={() => setShowCreate(s => !s)}
                        className="collapseBtn"
                        aria-expanded={showCreate}
                        title={showCreate ? 'Hide' : 'Show'}
                    >
                        <span>{editingUserId ? `Edit user #${editingUserId}` : 'Create user'}</span><span className={`chevron ${showCreate ? 'open' : ''}`}>▼</span>
                    </button>
                    {editingUserId && (
                        <button type="button" className="collapseBtn peakCancelEdit" onClick={resetUserForm}>
                            Cancel edit
                        </button>
                    )}
                </div>
                <div className={`togglePanel ${showCreate ? 'open' : ''}`}>
                    <div className="collapseInner">
                        <div className="labelP">{editingUserId ? `Edit user #${editingUserId}` : 'Create user'}</div>
                        <input className="paymentWidgetAddNumber" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder={editingUserId ? "New password (optional)" : "Password"} type="password" value={password} onChange={e => setPassword(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner WA" value={campaignerId} onChange={e => setCampaignerId(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="WA price" value={price} onChange={e => setPrice(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner WAButton" value={campaignerWAButton} onChange={e => setCampaignerWAButton(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="WAButton price" value={priceWAButton} onChange={e => setPriceWAButton(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner Imo" value={campaignerImo} onChange={e => setCampaignerImo(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Imo price" value={priceImo} onChange={e => setPriceImo(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner Viber" value={campaignerViber} onChange={e => setCampaignerViber(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Viber price" value={priceViber} onChange={e => setPriceViber(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner KakaoTalk" value={campaignerKakaoTalk} onChange={e => setCampaignerKakaoTalk(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="KakaoTalk price" value={priceKakaoTalk} onChange={e => setPriceKakaoTalk(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Campaigner Tg" value={campaignerTg} onChange={e => setCampaignerTg(e.target.value)} /><br /><br />
                        <input className="paymentWidgetAddNumber" placeholder="Tg price" value={priceTg} onChange={e => setPriceTg(e.target.value)} /><br /><br />
                        <select
                            className="paymentWidgetAddNumber"
                            value={deliveryMode}
                            onChange={e => setDeliveryMode(e.target.value)}
                        >
                            <option value="default">delivery_mode: default</option>
                            <option value="file_save">delivery_mode: file_save</option>
                            <option value="split">delivery_mode: split</option>
                            <option value="alternative">delivery_mode: alternative</option>
                            <option value="belwa">delivery_mode: belwa</option>
                            <option value="grouped_api">delivery_mode: grouped_api</option>
                            <option value="otp">delivery_mode: otp</option>
                        </select>
                        <br /><br />
                        <input
                            className="paymentWidgetAddNumber"
                            placeholder="Webhook URL (optional)"
                            value={webhookUrl}
                            onChange={e => setWebhookUrl(e.target.value)}
                        />
                        <br /><br />
                        <input
                            className="paymentWidgetAddNumber"
                            placeholder="Webhook URL (Telegram, optional)"
                            value={webhookUrlTelegram}
                            onChange={e => setWebhookUrlTelegram(e.target.value)}
                        />
                        <br /><br />
                        <input
                            className="paymentWidgetAddNumber"
                            placeholder={editingUserId ? "Balance" : "Start balance"}
                            value={startBalance}
                            onChange={e => setStartBalance(e.target.value)}
                        />
                        <br /><br />
                        <button onClick={handleRegister} className="addBalanceButton"><div className="addBalanceButtonText">{editingUserId ? 'Save user' : 'Create user'}</div></button>
                        {editingUserId && <button type="button" onClick={resetUserForm} className="peakSecondaryButton">Cancel</button>}
                        {message && <div style={{ marginTop: 10 }}>{message}</div>}
                    </div>
                </div>

                {/* таблицы */}

                {/* Кнопка показать/скрыть глобальную таблицу */}
                <div style={{ display:'flex', gap:12, alignItems:'center' }}>
                    <button
                        onClick={async () => {
                            const next = !showGlobalMsgs;
                            setShowGlobalMsgs(next);
                            if (next && globalMessages.length === 0) {
                                await fetchGlobalMessages(1, DEFAULT_PAGE_SIZE);
                            }
                        }}
                    >
                        {showGlobalMsgs ? 'Скрыть все сообщения (GLOBAL)' : 'Показать все сообщения (GLOBAL)'}
                    </button>
                </div>

                {showGlobalMsgs && (
                    <div style={{ marginTop: 24, width: "100%" }}>
                        <div className="labelP">All messages (GLOBAL)</div>

                        {/* Фильтры GLOBAL */}
                        <div className="tableToolbar" style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center', marginBottom:8}}>
                            <select value={gmFilters.type} onChange={e=>setGmFilters(f=>({...f, type:e.target.value}))}>
                                <option value="">Type: any</option>
                                <option value="whatsapp">whatsapp</option>
                                <option value="wabutton">wabutton</option>
                                <option value="telegram">telegram</option>
                                <option value="viber">viber</option>
                                <option value="imo">imo</option>
                                <option value="kakaotalk">kakaotalk</option>
                            </select>

                            <select value={gmFilters.status} onChange={e=>setGmFilters(f=>({...f, status:e.target.value}))}>
                                <option value="">Status: any</option>
                                <option value="checking">checking</option>
                                <option value="sent">sent</option>
                                <option value="delivered">delivered</option>
                                <option value="failed">failed</option>
                                <option value="undelivered">undelivered</option>
                                <option value="noaccount">noaccount</option>
                                <option value="expired">expired</option>
                            </select>

                            <select value={gmFilters.source} onChange={e=>setGmFilters(f=>({...f, source:e.target.value}))}>
                                <option value="">Source: any</option>
                                <option value="api">api</option>
                                <option value="lk">lk</option>
                                <option value="import">import</option>
                                <option value="bot">bot</option>
                                <option value="partner">partner</option>
                            </select>

                            <select value={gmFilters.method} onChange={e=>setGmFilters(f=>({...f, method:e.target.value}))}>
                                <option value="">Delivery: any</option>
                                <option value="api">api</option>
                                <option value="belwa">belwa</option>
                                <option value="file_save">file_save</option>
                                <option value="split_uni">split_uni</option>
                                <option value="split_dup">split_dup</option>
                            </select>

                            <input type="date" value={gmFilters.date_from} onChange={e=>setGmFilters(f=>({...f, date_from:e.target.value}))}/>
                            <input type="date" value={gmFilters.date_to}   onChange={e=>setGmFilters(f=>({...f, date_to:e.target.value}))}/>
                            <input placeholder="Phone contains…" value={gmFilters.phone} onChange={e=>setGmFilters(f=>({...f, phone:e.target.value}))}/>

                            <button onClick={() => fetchGlobalMessages(1, gmPagination.pageSize)}>Apply</button>
                            <button onClick={() => {
                                setGmFilters({type:'', status:'', source:'', method:'', date_from:'', date_to:'', phone:''});
                                fetchGlobalMessages(1, gmPagination.pageSize);
                            }}>Reset</button>
                        </div>

                        <Table height="420px" columns={globalMsgColumns} rows={globalMsgRows} />

                        <div className="tablePagination" style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 12 }}>
                            <button disabled={gmPagination.page === 1}
                                    onClick={() => fetchGlobalMessages(gmPagination.page - 1, gmPagination.pageSize)}>← Prev</button>
                            <span>Page {gmPagination.page} of {gmPagination.totalPages} ({gmPagination.total} messages)</span>
                            <button disabled={gmPagination.page === gmPagination.totalPages}
                                    onClick={() => fetchGlobalMessages(gmPagination.page + 1, gmPagination.pageSize)}>Next →</button>
                            <select value={gmPagination.pageSize}
                                    onChange={(e) => fetchGlobalMessages(1, Number(e.target.value))}>
                                {PAGE_SIZE_OPTIONS.map(size => <option key={size} value={size}>{size}</option>)}
                            </select>
                        </div>
                    </div>
                )}
                <div style={{ marginTop: 40, width: "100%" }}>
                    <div className="labelP">User list</div>
                    <Table height="300px" columns={userColumns} rows={userRows} />
                </div>
{selectedUserId && (
  <div style={{ display:'flex', gap:12, alignItems:'center', marginTop: 12 }}>
    <button
      onClick={async () => {
        const next = !showAllMsgs;
        setShowAllMsgs(next);
        if (next && allMessages.length === 0) {
          await fetchAllMessages(1, DEFAULT_PAGE_SIZE);
        }
      }}
    >
      {showAllMsgs ? 'Скрыть все сообщения пользователя' : 'Показать все сообщения пользователя'}
    </button>
  </div>
)}
{showAllMsgs && selectedUserId && (
  <div style={{ marginTop: 24, width: "100%" }}>
    <div className="labelP">All messages of user #{selectedUserId}</div>
{/* Фильтры для All user messages */}
<div className="tableToolbar" style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center', marginBottom:8}}>
  <select value={allFilters.type} onChange={e=>setAllFilters(f=>({...f, type:e.target.value}))}>
    <option value="">Type: any</option>
    <option value="whatsapp">whatsapp</option>
    <option value="wabutton">wabutton</option>
    <option value="telegram">telegram</option>
    <option value="viber">viber</option>
    <option value="imo">imo</option>
    <option value="kakaotalk">kakaotalk</option>
  </select>

  <select value={allFilters.status} onChange={e=>setAllFilters(f=>({...f, status:e.target.value}))}>
    <option value="">Status: any</option>
    <option value="checking">checking</option>
    <option value="sent">sent</option>
    <option value="delivered">delivered</option>
    <option value="failed">failed</option>
    <option value="undelivered">undelivered</option>
    <option value="noaccount">noaccount</option>
    <option value="expired">expired</option>
  </select>

  <select value={allFilters.source} onChange={e=>setAllFilters(f=>({...f, source:e.target.value}))}>
    <option value="">Source: any</option>
    <option value="api">api</option>
    <option value="lk">lk</option>
    <option value="import">import</option>
    <option value="bot">bot</option>
    <option value="partner">partner</option>
  </select>

  <select value={allFilters.method} onChange={e=>setAllFilters(f=>({...f, method:e.target.value}))}>
    <option value="">Delivery: any</option>
    <option value="api">api</option>
    <option value="belwa">belwa</option>
    <option value="file_save">file_save</option>
    <option value="split_uni">split_uni</option>
    <option value="split_dup">split_dup</option>
  </select>

  <input
    type="date"
    value={allFilters.date_from}
    onChange={e=>setAllFilters(f=>({...f, date_from:e.target.value}))}
  />
  <input
    type="date"
    value={allFilters.date_to}
    onChange={e=>setAllFilters(f=>({...f, date_to:e.target.value}))}
  />

  <input
    placeholder="Phone contains…"
    value={allFilters.phone}
    onChange={e=>setAllFilters(f=>({...f, phone:e.target.value}))}
  />

<button onClick={() => fetchAllMessages(1, allPagination.pageSize)}>
  Apply
</button>

<button
  onClick={() => {
    setAllFilters({ type:'', status:'', source:'', method:'', date_from:'', date_to:'', phone:'' });
    fetchAllMessages(1, allPagination.pageSize);
  }}
>
  Reset
</button>
</div>
    <Table height="420px" columns={allMsgColumns} rows={allMsgRows} />
    <div className="tablePagination" style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 12 }}>
      <button disabled={allPagination.page === 1}
              onClick={() => fetchAllMessages(allPagination.page - 1, allPagination.pageSize)}>← Prev</button>
      <span>Page {allPagination.page} of {allPagination.totalPages} ({allPagination.total} messages)</span>
      <button disabled={allPagination.page === allPagination.totalPages}
              onClick={() => fetchAllMessages(allPagination.page + 1, allPagination.pageSize)}>Next →</button>
      <select value={allPagination.pageSize}
              onChange={(e) => fetchAllMessages(1, Number(e.target.value))}>
        {PAGE_SIZE_OPTIONS.map(size => <option key={size} value={size}>{size}</option>)}
      </select>
    </div>
  </div>
)}
                {selectedUserId && userCampaigns.length > 0 && (
                    <div style={{ marginTop: 40, width: "100%" }}>
                        <div className="labelP">User campaigns #{selectedUserId}</div>
                        <Table height="400px" columns={campaignColumns} rows={campaignRows} />
                    </div>
                )}

                {selectedCampaignId && campaignMessages.length > 0 && (
                    <div style={{ marginTop: 40, width: "100%" }}>
                        <div className="labelP">
                            Campaign messages #{selectedCampaignId}
                        </div>
<div className="tableToolbar" style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center', marginBottom:8}}>
  <select value={cmFilters.type} onChange={e=>setCmFilters(f=>({...f, type:e.target.value}))}>
    <option value="">Type: any</option>
    <option value="whatsapp">whatsapp</option>
    <option value="wabutton">wabutton</option>
    <option value="telegram">telegram</option>
    <option value="viber">viber</option>
    <option value="imo">imo</option>
    <option value="kakaotalk">kakaotalk</option>
  </select>
  <select value={cmFilters.status} onChange={e=>setCmFilters(f=>({...f, status:e.target.value}))}>
    <option value="">Status: any</option>
    <option value="checking">checking</option>
    <option value="sent">sent</option>
    <option value="delivered">delivered</option>
    <option value="failed">failed</option>
    <option value="undelivered">undelivered</option>
    <option value="noaccount">noaccount</option>
    <option value="expired">expired</option>
  </select>
  <select value={cmFilters.source} onChange={e=>setCmFilters(f=>({...f, source:e.target.value}))}>
    <option value="">Source: any</option>
    <option value="api">api</option>
    <option value="lk">lk</option>
    <option value="import">import</option>
    <option value="bot">bot</option>
    <option value="partner">partner</option>
  </select>
  <select value={cmFilters.method} onChange={e=>setCmFilters(f=>({...f, method:e.target.value}))}>
    <option value="">Delivery: any</option>
    <option value="api">api</option>
    <option value="belwa">belwa</option>
    <option value="file_save">file_save</option>
    <option value="split_uni">split_uni</option>
    <option value="split_dup">split_dup</option>
  </select>
  <input type="date" value={cmFilters.date_from} onChange={e=>setCmFilters(f=>({...f, date_from:e.target.value}))}/>
  <input type="date" value={cmFilters.date_to} onChange={e=>setCmFilters(f=>({...f, date_to:e.target.value}))}/>
  <input placeholder="Phone contains…" value={cmFilters.phone} onChange={e=>setCmFilters(f=>({...f, phone:e.target.value}))}/>
<button onClick={() => fetchCampaignMessages(selectedCampaignId, 1, pagination.pageSize)}>
  Apply
</button>

<button
  onClick={() => {
    setCmFilters({ type:'', status:'', source:'', method:'', date_from:'', date_to:'', phone:'' });
    fetchCampaignMessages(selectedCampaignId, 1, pagination.pageSize);
  }}
>
  Reset
</button></div>
                        <Table height="400px" columns={msgColumns} rows={msgRows} />

                        {/* пагинация */}
                        <div className="tablePagination" style={{
                            marginTop: 12,
                            display: "flex",
                            alignItems: "center",
                            gap: 12
                        }}>
                            <button
                                disabled={pagination.page === 1}
                                onClick={() =>
                                    fetchCampaignMessages(
                                        selectedCampaignId,
                                        pagination.page - 1,
                                        pagination.pageSize
                                    )
                                }
                            >
                                ← Prev
                            </button>

                            <span>
                Page {pagination.page} of {pagination.totalPages} ({pagination.total} messages)
            </span>

                            <button
                                disabled={pagination.page === pagination.totalPages}
                                onClick={() =>
                                    fetchCampaignMessages(
                                        selectedCampaignId,
                                        pagination.page + 1,
                                        pagination.pageSize
                                    )
                                }
                            >
                                Next →
                            </button>

                            <select
                                value={pagination.pageSize}
                                onChange={(e) =>
                                    fetchCampaignMessages(selectedCampaignId, 1, Number(e.target.value))
                                }
                            >
                                {PAGE_SIZE_OPTIONS.map(size => (
                                    <option key={size} value={size}>{size}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                <div className="campaignerStatsToolbar">
                    <div className="labelP" style={{ margin: 0 }}>
                        Campaigner stats - last {campaignerStatsDays} days
                    </div>
                    <button
                        className="peakSecondaryButton"
                        type="button"
                        onClick={() => loadCampaignerStats(
                            campaignerStatsDays === CAMPAIGNER_EXTENDED_DAYS
                                ? CAMPAIGNER_DEFAULT_DAYS
                                : CAMPAIGNER_EXTENDED_DAYS
                        )}
                        disabled={campaignerStatsLoading}
                    >
                        {campaignerStatsLoading
                            ? 'Loading...'
                            : campaignerStatsDays === CAMPAIGNER_EXTENDED_DAYS
                                ? 'Load 5 days'
                                : 'Load 29 days'}
                    </button>
                    {campaignerStatsMessage && (
                        <span className="campaignerStatsMessage">{campaignerStatsMessage}</span>
                    )}
                </div>

                {CHANNELS.map(ch => {
                    const data = campaignerIdsByChannel[ch] || [];
                    const days = daysByChannel[ch] || [];
                    const gridObj = buildGrid(data);
                    const columns = makeGridColumns(days, ch.toUpperCase());
                    const rows = makeGridRows(gridObj, days, balanceMap);
                    return (
                        <div key={ch} style={{ marginTop: 40, width: "100%" }}>
                            <div className="labelP">{ch.toUpperCase()} Campaigners</div>
                            <Table height="350px" columns={columns} rows={rows} />
                        </div>
                    );
                })}
<div style={{ marginTop: 40, width: "100%" }}>
                    <div className="labelP">Saved files</div>

<div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12, flexWrap: 'wrap' }}>
    <select
        className="paymentWidgetAddNumber"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
    >
        {fileDates.map(d => <option key={d} value={d}>{d}</option>)}
    </select>

    <select
        className="paymentWidgetAddNumber"
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
    >
        <option value="filesave">filesave</option>
        <option value="split">split</option>
    </select>

    <select
        className="paymentWidgetAddNumber"
        value={selectedChannel}
        onChange={(e) => setSelectedChannel(e.target.value)}
    >
        <option value="whatsapp">whatsapp</option>
        <option value="wabutton">wabutton</option>
        <option value="telegram">telegram</option>
        <option value="viber">viber</option>
        <option value="imo">imo</option>
        <option value="kakaotalk">kakaotalk</option>
    </select>

    <button onClick={() => loadFiles(selectedDate, selectedType, selectedChannel)}>Refresh</button>
</div>

{(() => {
    const grouped = groupFilesByBucket(fileList);
    const orderedBuckets = BUCKET_CONFIG.map(bucket => bucket.key);
    const customGrouped = groupFilesByCustomBucket(fileList);
    const customBuckets = Object.keys(customGrouped).sort((a, b) => Number(a) - Number(b));

    const timeBucketNodes = orderedBuckets.map(bucket => {
        const files = grouped[bucket] || [];
        if (!files.length) return null;

        return (
            <div key={bucket} style={{ marginBottom: 28 }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 10,
                    gap: 12,
                    flexWrap: 'wrap'
                }}>
                    <div className="labelP" style={{ margin: 0 }}>
                        {bucketLabel(bucket)} — {files.length} file(s)
                    </div>

                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        <button onClick={() => downloadMergedBucket(bucket)}>
                            Download all
                        </button>
                        <button onClick={() => downloadMergedStatuses(bucket)}>
                            Statuses all
                        </button>
                        <button onClick={() => downloadMergedXlsx(bucket, false)}>
                            XLSX all
                        </button>
                    </div>
                </div>

                <Table
                    height="220px"
                    columns={[
                        { key: 'name', label: 'File' },
                        { key: 'size', label: 'Size (bytes)' },
                        { key: 'messageCount', label: 'Messages' },
                        { key: 'mtime', label: 'Modified' },
                        { key: 'actions', label: '' },
                    ]}
                    rows={files.map(f => ({
                        name: f.name,
                        size: f.size,
                        messageCount: Number(f.messageCount || 0).toLocaleString('en-US'),
                        mtime: new Date(f.mtime).toLocaleString('en-GB', { timeZone: 'UTC' }),
                        actions: (
                            <div style={{ display: 'flex', gap: 8 }}>
                                <button onClick={() => downloadFile(f.name)}>Download</button>
                                <button onClick={() => downloadStatuses(f.name)}>Statuses</button>
                                <button onClick={() => downloadXlsx(f.name, false)}>XLSX</button>
                            </div>
                        ),
                    }))}
                />
            </div>
        );
    });

    return (
        <>
            {timeBucketNodes}

            {customBuckets.length > 0 && (
                <div className="customFilesDivider">
                    <span>Custom buckets</span>
                </div>
            )}

            {customBuckets.map(bucket => {
                const files = customGrouped[bucket] || [];
                if (!files.length) return null;

                return (
                    <div key={`custom-${bucket}`} style={{ marginBottom: 28 }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 10,
                            gap: 12,
                            flexWrap: 'wrap'
                        }}>
                            <div className="labelP" style={{ margin: 0 }}>
                                Custom bucket {bucket} - {files.length} file(s)
                            </div>

                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                <button onClick={() => downloadMergedBucket(bucket)}>
                                    Download all
                                </button>
                                <button onClick={() => downloadMergedStatuses(bucket)}>
                                    Statuses all
                                </button>
                                <button onClick={() => downloadMergedXlsx(bucket, false)}>
                                    XLSX all
                                </button>
                            </div>
                        </div>

                        <Table
                            height="220px"
                            columns={[
                                { key: 'name', label: 'File' },
                                { key: 'size', label: 'Size (bytes)' },
                                { key: 'messageCount', label: 'Messages' },
                                { key: 'mtime', label: 'Modified' },
                                { key: 'actions', label: '' },
                            ]}
                            rows={files.map(f => ({
                                name: f.name,
                                size: f.size,
                                messageCount: Number(f.messageCount || 0).toLocaleString('en-US'),
                                mtime: new Date(f.mtime).toLocaleString('en-GB', { timeZone: 'UTC' }),
                                actions: (
                                    <div style={{ display: 'flex', gap: 8 }}>
                                        <button onClick={() => downloadFile(f.name)}>Download</button>
                                        <button onClick={() => downloadStatuses(f.name)}>Statuses</button>
                                        <button onClick={() => downloadXlsx(f.name, false)}>XLSX</button>
                                    </div>
                                ),
                            }))}
                        />
                    </div>
                );
            })}
        </>
    );
})()}
                    
                </div>
                <div style={{ marginTop: 30, width: "100%" }}>
                    <div className="labelP">Settings</div>

                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                        <div>
                            <div>send_cron_template</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={sendCronValue}
                                onChange={e => setSendCronValue(e.target.value)}
                            />
                            <button onClick={saveSendCron}>Save</button>
                        </div>

                        <div>
                            <div>checkwa_next_key_index</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={nextKeyValue}
                                onChange={e => setNextKeyValue(e.target.value)}
                            />
                            <button onClick={saveNextKey}>Save</button>
                        </div>

                        <div>
                            <div>checkwa_load_limit</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={checkwaLoadLimitValue}
                                onChange={e => setCheckwaLoadLimitValue(e.target.value)}
                            />
                            <button onClick={saveCheckwaLoadLimit}>Save</button>
                        </div>

                        <button onClick={fetchSettings}>Refresh</button>
                    </div>

                    {settingsMessage && (
                        <div style={{ marginTop: 10 }}>
                            {settingsMessage}
                        </div>
                    )}
                </div>
                <div style={{ marginTop: 20 }}>
                    <div className="labelP">Manual checkwa send</div>

                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                        <div>
                            <div>keyIndex</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={manualKeyIndex}
                                onChange={e => setManualKeyIndex(e.target.value)}
                                placeholder="0"
                            />
                        </div>

                        <div>
                            <div>limit</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={manualLimit}
                                onChange={e => setManualLimit(e.target.value)}
                                placeholder="1000"
                            />
                        </div>

                        <button onClick={runManualCheckwaSend}>
                            Run send now
                        </button>
                    </div>

                    {manualSendMessage && (
                        <div style={{ marginTop: 10 }}>
                            {manualSendMessage}
                        </div>
                    )}
                </div>
                <div className="customBucketPanel">
                    <div className="labelP">Custom bucket save</div>

                    <div className="customBucketControls">
                        <div>
                            <div>limit</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={customBucketLimit}
                                onChange={e => setCustomBucketLimit(e.target.value)}
                                placeholder="1000"
                            />
                        </div>

                        <div>
                            <div>users</div>
                            <select
                                className="paymentWidgetAddNumber"
                                value={customBucketUserScope}
                                onChange={e => setCustomBucketUserScope(e.target.value)}
                            >
                                <option value="all">all users</option>
                                <option value="single">one user</option>
                            </select>
                        </div>

                        {customBucketUserScope === 'single' && (
                            <div>
                                <div>userId</div>
                                <input
                                    className="paymentWidgetAddNumber"
                                    value={customBucketUserId}
                                    onChange={e => setCustomBucketUserId(e.target.value)}
                                    placeholder="25"
                                />
                            </div>
                        )}

                        <div>
                            <div>channel</div>
                            <select
                                className="paymentWidgetAddNumber"
                                value={customBucketChannel}
                                onChange={e => setCustomBucketChannel(e.target.value)}
                            >
                                <option value="all">all channels</option>
                                <option value="whatsapp">whatsapp only</option>
                                <option value="wabutton">wabutton only</option>
                                <option value="telegram">telegram only</option>
                                <option value="viber">viber only</option>
                                <option value="imo">imo only</option>
                                <option value="kakaotalk">kakaotalk only</option>
                            </select>
                        </div>

                        <button onClick={runCustomBucketSave} disabled={customBucketSaving}>
                            {customBucketSaving ? 'Saving custom bucket...' : 'Save custom bucket'}
                        </button>
                    </div>

                    {customBucketMessage && (
                        <div style={{ marginTop: 10 }}>
                            {customBucketMessage}
                        </div>
                    )}
                </div>
                <div style={{ marginTop: 24, width: "100%" }}>
                    <div className="labelP">Manual balance top up</div>

                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                        <div>
                            <div>User</div>
                            <select
                                className="paymentWidgetAddNumber"
                                value={manualPaymentUserId || selectedUserId || ''}
                                onChange={e => setManualPaymentUserId(e.target.value)}
                            >
                                <option value="">Select user</option>
                                {users.map(user => (
                                    <option key={user.id} value={user.id}>
                                        #{user.id} — {user.username} — balance: ${user.balance}
                                        {user.debt !== undefined ? ` — debt: $${user.debt}` : ''}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <div>Amount</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={manualPaymentAmount}
                                onChange={e => setManualPaymentAmount(e.target.value)}
                                placeholder="100.00"
                            />
                        </div>

                        <label style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 18 }}>
                            <input
                                type="checkbox"
                                checked={manualPaymentWithDebt}
                                onChange={e => setManualPaymentWithDebt(e.target.checked)}
                            />
                            Add to debt
                        </label>

                        <div>
                            <div>Comment</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={manualPaymentComment}
                                onChange={e => setManualPaymentComment(e.target.value)}
                                placeholder="Optional comment"
                            />
                        </div>

                        <button onClick={createManualPayment} className="addBalanceButton">
                            <div className="addBalanceButtonText">Top up balance</div>
                        </button>
                    </div>

                    {manualPaymentMessage && (
                        <div style={{ marginTop: 10 }}>
                            {manualPaymentMessage}
                        </div>
                    )}
                </div>
                <div style={{ marginTop: 24, width: "100%" }}>
                    <div className="labelP">Manual balance withdraw</div>

                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                        <div>
                            <div>User</div>
                            <select
                                className="paymentWidgetAddNumber"
                                value={manualWithdrawUserId || selectedUserId || ''}
                                onChange={e => setManualWithdrawUserId(e.target.value)}
                            >
                                <option value="">Select user</option>
                                {users.map(user => (
                                    <option key={user.id} value={user.id}>
                                        #{user.id} — {user.username} — balance: ${user.balance}
                                        {user.debt !== undefined ? ` — debt: $${user.debt}` : ''}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <div>Amount</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={manualWithdrawAmount}
                                onChange={e => setManualWithdrawAmount(e.target.value)}
                                placeholder="100.00"
                            />
                        </div>

                        <label style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 18 }}>
                            <input
                                type="checkbox"
                                checked={manualWithdrawFromDebt}
                                onChange={e => setManualWithdrawFromDebt(e.target.checked)}
                            />
                            Reduce debt too
                        </label>

                        <div>
                            <div>Comment</div>
                            <input
                                className="paymentWidgetAddNumber"
                                value={manualWithdrawComment}
                                onChange={e => setManualWithdrawComment(e.target.value)}
                                placeholder="Optional comment"
                            />
                        </div>

                        <button onClick={createManualWithdraw} className="addBalanceButton">
                            <div className="addBalanceButtonText">Withdraw</div>
                        </button>
                    </div>

                    {manualWithdrawMessage && (
                        <div style={{ marginTop: 10 }}>
                            {manualWithdrawMessage}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
